export enum ETipoBloqueioCliente{
  Movimentacao = 0,
  Inadimplencia = 1,
  NegativadoSPC = 2,
  LimiteCredito = 3
}
